import {Constructor} from "../../global/constructor";
import ObjectModelAction from "../models/objectModelActions/objectModelAction";
import {Hash} from "../interfaces/hashInterfaces";
import {ObjectHelper} from "../helpers/objectHelper";
import {ArrayHelper} from "../helpers/arrayHelper";
import ObjectModelBuilderModel from "../models/tracked/objectModelBuilderModel";
import Vue from "vue";
import ObjectModel from "../models/objectModel";
import {ObjectModelDefaultActionType} from "~/enums/objectModelDefaultActionType";
import {ObjectModelActionType} from "~/enums/objectModelActionType";

export default function ObjectModelActionContainer<TBase extends Constructor<ObjectModelBuilderModel>>(Base: TBase) {
  return class ObjectModelContainer extends Base {
    id: string;
    client_id: string;
    object_model_default_actions: Hash<ObjectModelAction> = {};
    object_model_actions: Hash<ObjectModelAction> = {};
    saveChangesToStore: () => void;

    get objectModelDefaultActionsArray(): ObjectModelAction[] {
      return ObjectHelper.toArray(this.object_model_default_actions)
        .sort((a, b) => a.sort_order - b.sort_order);
    }

    get hasActions(): boolean {
      return Object.keys(this.object_model_actions).length > 0;
    }

    get objectModelActionsArray(): ObjectModelAction[] {
      return ObjectHelper.toArray(this.object_model_actions)
        .sort((a, b) => a.sort_order - b.sort_order);
    }

    get allObjectModelActions(): ObjectModelAction[] {
      return [...this.objectModelDefaultActionsArray, ...this.objectModelActionsArray]
    }

    findObjectModelAction(id: string): ObjectModelAction {
      return this.allObjectModelActions.find((f) => f.id === id || f.client_id === id);
    }

    findObjectModelActionContainer(id: string): ObjectModelContainer {
      if (this instanceof ObjectModelContainer) {
        if (this.id === id || this.client_id === id) {
          return this;
        }
      }
    }

    get bulkAllowableActions(): ObjectModelAction[] {
      return this.allObjectModelActions.filter((f) => f.allows_bulk)
    }

    get allowedMainActions(): ObjectModelAction[] {
      const createActions = this.objectModelDefaultActionsArray.filter(action => {
        return action.default_action_type === ObjectModelDefaultActionType.Create;
      });
      const runProcessActions = this.objectModelActionsArray.filter(action => {
        return action.action_type === ObjectModelActionType.RunProcess;
      });
      return [
        ...createActions,
        ...runProcessActions,
      ];
    }

    updateActionPositions(movedAction: ObjectModelAction, position: number) {
      ArrayHelper.updatePositionsByProp(this.objectModelActionsArray, movedAction, position, 'sort_order');
    }

    updateActionPositionsForParent(parent: ObjectModel, movedAction: ObjectModelAction, position: number) {
      ArrayHelper.updatePositionsByProp(parent.objectModelActionsArray, movedAction, position, 'sort_order');
    }

    moveActionToParent(actionId: string, parentId: string, newPosition: number) {
      const action = this.findObjectModelAction(actionId);
      const newParent = this.findObjectModelActionContainer(parentId);
      const oldParent = action.parent;

      if (newParent === oldParent) {
        action.sort_order = newPosition;
      } else {
        oldParent.trackCreationDeletion(action.client_id, action.asJson(), null, action);

        action.sort_order = newPosition;
        oldParent.trackCreationDeletion(action.client_id, null, action.asJson(), action);
      }
      newParent.updateActionPositions(action, newPosition);

      if (newParent !== oldParent) {
        Vue.delete(oldParent[action.rootName], action.client_id);
        action.parent = newParent;
        Vue.set(newParent[action.rootName], action.client_id, action);
      }

      this.saveChangesToStore();
    }

  };
}